import { useEffect, useState } from "react";
import Detail from "../components/structure/Detail";
import { callBackendAPI } from "../utils/helpers";
import { REST_API_METHODS } from "../utils/constants";
import TitleSetter from "../components/common/TitleSetter";

const PrivacyPolicy = () => {
  const [description, setDescription] = useState("");

  useEffect(() => {
    getPrivacyDetails();
  }, []);

  const getPrivacyDetails = async () => {
    try {
      const response = await callBackendAPI(
        "getContents?type=2",
        REST_API_METHODS.GET
      );
      if (!!response.status) {
        setDescription(response.data.contents);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <TitleSetter title={"Privacy Policy"} />
      <Detail title={"Privacy Policy"} description={description} />
    </>
  );
};

export default PrivacyPolicy;
